import { render, staticRenderFns } from "./AddFaqCategory.vue?vue&type=template&id=03acd287"
import script from "./AddFaqCategory.vue?vue&type=script&lang=js"
export * from "./AddFaqCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports